import PlanCrud from './PlanCrud.vue'
export { PlanCrud }
export default PlanCrud
